export default __webpack_public_path__ + "assets/Insets_Article.jpg";